import React from 'react'

export default function FaceFeature({ scaleX, fill, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`} fill="none">
      <path
        d="M11.0476 1.47013L9.51764 3.5601C9.51764 3.5601 2.46764 2.57016 2.24764 3.12016C2.02764 3.67016 2.35764 16.0002 0.817641 20.4002C0.817641 20.4002 0.847643 15.6501 0.487643 11.7001C0.0376432 6.77011 -0.652359 2.33014 1.36764 1.35014C4.99764 -0.399863 11.0476 1.47013 11.0476 1.47013Z"
        fill={fill}
      />
      <path
        d="M13.1074 1.47013L14.6374 3.5601C14.6374 3.5601 21.6874 2.57016 21.9074 3.12016C22.1274 3.67016 21.7974 16.0002 23.3374 20.4002C23.3374 20.4002 23.3074 15.6501 23.6674 11.7001C24.1174 6.77011 24.8074 2.33014 22.7874 1.35014C19.1574 -0.399863 13.1074 1.47013 13.1074 1.47013Z"
        fill={fill}
      />
      <path d="M18.1678 26.7903L11.9978 22.7202L5.98779 26.7903L11.9978 35.1603L18.1678 26.7903Z" fill={fill} />
    </g>
  )
}
